import { useToaster } from '@/components/shared/ToasterProvider'

export default function useCopyText() {
  const showToast = useToaster()
  return (text: string, successMessage: string, errorMessage: string) => {
    navigator.clipboard.writeText(text)
      .then(() => showToast({ message: successMessage, variant: 'success' }))
      .catch(() => showToast({ message: errorMessage, variant: 'danger' }))
  }
}
